import { useContext } from 'react';
import LoginContext from '../contexts/LoginContext';

/**
 * Custom hook to access the LoginContext.
 *
 * @returns context - the context value for managing login state, including user, setUser, and logout.
 */
const useLoginContext = () => {
  const context = useContext(LoginContext);

  if (!context) {
    throw new Error('useLoginContext must be used within a LoginProvider');
  }

  return context;
};

export default useLoginContext;
